webpackJsonp([267695594480457],{

/***/ 76:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _gatsbyLink = __webpack_require__(55);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NarrowContainer = _glamorous2.default.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    width: theme.main.maxWidths.text
	  };
	});
	
	var TermsOfUse = function TermsOfUse() {
	  return _react2.default.createElement(
	    _Section2.default,
	    { css: { paddingTop: "calc(100px + 1rem)" } },
	    _react2.default.createElement(
	      NarrowContainer,
	      null,
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Terms of Use"
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "ol",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Introduction"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Thank you for using Manta Equipment, a service provided by EXN SIA. These Terms of Use cover your use of Manta Equipment. Detailed information on how we use your data can be found in our ",
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/privacy" },
	              "Privacy Policy"
	            ),
	            ". By using Manta Equipment, you must agree to these Terms. If you do not understand or do not accept any part of them, please do not use the Service."
	          ),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Definitions"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "The ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Service"
	            ),
	            " or ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Manta"
	            ),
	            " is the web application called \"Manta Equipment\", available on the manta.equipment website. It is used by institutions for managing equipment rental."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "You"
	            ),
	            " are the institution that is using or signing up to use the Service."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "A ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Resource"
	            ),
	            " is an entity in Manta, such as a physical item, a location (e.g. room), or service (printing appointment), that can be made available for booking."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "A ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Patron"
	            ),
	            " is someone who uses Manta to lend items from the You or one of your departments."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Staff"
	            ),
	            " refers to users of the Service with elevated privileges that are in charge of handing out and receiving items from Patrons and tracking the bookings in Manta."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "A ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Booking"
	            ),
	            " is an agreement between You and a Patron about lending out a Resource to them under mutually agreed conditions."
	          ),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Usage of Manta"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "You are to use the Service only as provided in these Terms, and in accordance with instructions presented to you during the on-boarding process. Manta may only be used by You; that is, no other institutions, businesses or other entities may use Manta unless agreed previously in writing with us. You are responsible that all Staff and Patrons use the Service accordingly."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "You agree not to copy, modify, resell, loan, distribute or create derivative work of Manta or any portion of it. You must obtain written permission from us to modify, decompile, or otherwise reverse engineer or extract source code from the Service."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "We bear no responsibility for any of the Resources you add to the System: we do not accept any responsibility for overdue Bookings, damaged or lost Resources, any fines thereby incurred, or any misconduct by Patrons or Staff through the use of the Service."
	          ),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Subscriptions"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "We provide Manta to You on a subscription basis. The term of the subscription is agreed upon during the purchase process, and we invoice you accordingly. Throughout the course of the subscription, we provide you access to the Service via the application website and ensure that you can reasonably access the Service and use it, subject to any technical requirements of the Service. However, we are not required to issue updates to the Service to ensure compliance with older operating systems, browsers or other technical features that may prevent you from using the Service."
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Cancellation"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Your subscription will remain in effect and will automatically renew at the end of its term unless you notify us 1 month before in writing. The renewed subscription will maintain the same configuration and fee schedule as the previous one, unless you have requested a change of configuration, or if we have notified you of changes beforehand that you have accepted."
	          ),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Modifying and Terminating Manta"
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Software Updates"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "We strive to continuously improve Manta, and tailor it to our clients as much as possible. As such, we may issue updates to the Service to improve performance, security or user experience. We may also need to make changes to comply with the law or to prevent abuse of Manta. For any improvements that we reasonably believe will affect your usage of the Service, we will notify You in advance via the support channel agreed upon during the on-boarding process. In cases of security concerns or degradation to core functionality, we may need to make changes to Manta without giving notice to You."
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Suspension and Termination of Service"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "You may discontinue using Manta Equipment at any time, but you must notify us at least 1 month in advance for us to complete the account termination process. No refunds will be issued for the period of the subscription that you do not use the Service."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "We ensure that the Service will be provided to You for the duration of your subscription, subject to your compliance of the terms. After the end of the subscription, we reserve the right to terminate your access to the service without prior notice."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "We additionally reserve the right to suspend or terminate your access to the Service without prior notice during the subscription in case you abuse our systems, conduct illegal activity on or via the Service, or in case of any other act performed by You that may cause us legal liability."
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Discontinuation of Service"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "In case EXN SIA decides or is forced to discontinue providing the Service, we will notify you at least 3 months before the end of your subscription. Prior to discontinuation, we will allow you to retrieve all the information stored in Manta."
	          ),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Fees and Payments"
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Initial Setup Fee"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "You agree to pay the Initial Setup Fee as quoted to you by the Business Development Representative. This fee includes database and cloud instance setup, migration of existing data from legacy systems, Single Sign-On integration and liaising with institution IT departments, live onboarding with key staff for initial use and other preparatory work needed."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "If you change your configuration, such as the number of departments, users, or optional features during your subscription, then you agree to pay an additional setup fee when applicable, as quoted to you by your Account Manager."
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Annual Subscription Fee"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "You agree to pay the Initial Setup Fee as quoted to you by the Business Development Representative. The annual subscription includes all server hosting and maintenance costs, data backups and premium support available via the channel agreed upon during on-boarding. We will assign an Account Manager who will act as your primary support contact. The annual subscription includes any updates made to Manta Equipment during your subscription."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "We reserve the right to suspend or terminate your subscription in the case when a payment has not been received by the due date."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "EXN SIA may update the Annual Subscription Fee at the end of a subscription; in case of a renewal, the fees are to be paid at the updated levels quoted to you. We reserve the right to adjust the pricing model in our sole discretion."
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Pro-rata payments"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "In case of irregular usage schedules, the above fees may be re-calculated to match the exact duration of your subscription on a pro-rata basis."
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Refunds"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "All of the fees listed above are non-refundable; no refunds or credits will be issued in case you decide to discontinue using Manta during your subscription."
	          ),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Warranties and Disclaimers"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Manta warrants to you that the Service performs in accordance with the documentation provided on the manta.equipment marketing website throughout the course of your subscription, subject to any technical requirements of the Service. We also warrant to exercise commercially reasonable effort to remediate any technical issues of the Service in response to written notice of such issues."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Other than stated above, we make no commitments about specific functionality, reliability, or suitability of the Service to your needs."
	          ),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Liability of Manta"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "EXN SIA, its subcontractors and affiliates are not responsible or liable for:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              "any losses that were not caused by our breach of these Terms;"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "any loss or damage that was not, a reasonably foreseeable consequence of us breaching the Terms;"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "damaged or lost Resources, overdue Bookings and any fines thereby incurred, or any misconduct by Patrons or Staff through the use of the Service;"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "any losses incurred by loss of system availability or malfunction due to Force Majeure, i.e. cause beyond its reasonable control;"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "data lost or damaged through accident or negligence of Staff or Patrons."
	            )
	          )
	        )
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Last Edited on 2019-07-07"
	      )
	    )
	  );
	};
	
	exports.default = TermsOfUse;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-8fc6548100f7176db1de.js